<template>
  <div class="modal_wrap" :class="{ on: show }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <!--<h1 class="h1"></h1>-->
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div class="center">
              탈퇴하시면 지금까지 이용하신 기록이<br />
              모두 삭제되고 30일 후 재가입 가능합니다.<br />
              <br />
              <span class="color bold">그래도 삭제하시겠습니까?</span><br />
              <br />
              불편한 사항이 있으시다면<br />
              <button class="line_btn" v-on:click="$emit('gotoInquiry')">
                1:1 문의
              </button>
              페이지에서<br />
              불편하신 사항을 알려 주세요.<br />
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" v-on:click="$emit('withdraw')">
              탈퇴하기
            </button>
            <button class="btn" v-on:click="$emit('close')">닫기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Withdrawal.vue',
  props: {
    show: Boolean,
  },
};
</script>

<style scoped></style>
